import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@expresslogistics.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("el_token", res.data.token);
      localStorage.setItem("el_email", res.data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch {
      toast.error("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:block relative">
        <img
          src="https://images.pexels.com/photos/4483938/pexels-photo-4483938.jpeg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#141110]/85 to-[#141110]/50" />
        <div className="relative z-10 p-14 text-[#F0EBE1] h-full flex flex-col justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#C25B48] grid place-items-center font-display font-bold">
              E
            </div>
            <div className="font-display text-lg">Express Logistics</div>
          </Link>
          <div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 mb-4">Admin console</div>
            <div className="font-display text-4xl leading-tight max-w-md">
              Every lead, every conversation, every move — one dashboard.
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="w-full max-w-md rounded-2xl border border-border bg-background p-10 shadow-sm"
        >
          <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary grid place-items-center mb-6">
            <Lock className="w-5 h-5" />
          </div>
          <h1 className="font-display text-3xl mb-2">Admin sign-in</h1>
          <p className="text-sm text-muted-foreground mb-8">
            Manage quote requests, contacts and chatbot conversations.
          </p>

          <div className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider mb-2 block">Email</Label>
              <Input
                data-testid="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider mb-2 block">Password</Label>
              <Input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <Button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="mt-6 w-full h-11 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>

          <Link to="/" className="mt-6 block text-center text-sm text-muted-foreground hover:text-foreground">
            ← Back to site
          </Link>
        </form>
      </div>
    </div>
  );
}
